interface RiskScoreCardProps {
  composite: 'LOW' | 'MODERATE' | 'HIGH' | 'CRITICAL';
  score: number;
}

export function RiskScoreCard({ composite, score }: RiskScoreCardProps) {
  const isHighRisk = composite === 'HIGH' || composite === 'CRITICAL';

  const bgColor = isHighRisk ? 'bg-red-50' : 'bg-green-50';
  const borderColor = isHighRisk ? 'border-red-200' : 'border-green-200';
  const textColor = isHighRisk ? 'text-red-700' : 'text-green-700';

  return (
    <div className={`card ${bgColor} ${borderColor} border-2`}>
      <div className="flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="text-center md:text-left w-full md:w-auto">
          <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-2">
            Composite SDOH Risk
          </h2>
          <p className={`text-3xl md:text-4xl font-bold ${textColor}`}>
            {composite}
          </p>
        </div>
        <div className={`text-5xl md:text-6xl font-bold ${textColor}`}>
          {score}
        </div>
      </div>
    </div>
  );
}
